module.exports = __webpack_public_path__ + "img/ep8-5a.8a01904b.png";